// Limits and labels of the Domain Event tab. They mirror reminder_setup/domain_event/controller.js.

export const EVENT_KEY_RE = /^[a-z][a-z0-9_]*(\.[a-z][a-z0-9_]*)+$/;
export const PAYLOAD_KEY_RE = /^[a-z][a-z0-9_]{0,49}$/;
export const MAX_EXTRA_KEYS = 30;

// Every emit() carries these; the server always adds them to payload_schema.
export const REQUIRED_PAYLOAD = [
  { key: "subject_key", label: "Subject (U:<user id>, or - for a platform-level record)", data_type: "TEXT" },
  { key: "reference_key", label: "Record (the source REFERENCE value)", data_type: "TEXT" },
];
export const REQUIRED_PAYLOAD_KEYS = REQUIRED_PAYLOAD.map((item) => item.key);

export const PAYLOAD_TYPE_LABEL = {
  INT: "Number",
  NUMERIC: "Decimal",
  TEXT: "Text",
  DATE: "Date",
  TIMESTAMP: "Date & time",
  BOOLEAN: "Yes / No",
};
export const PAYLOAD_TYPE_OPTIONS = Object.entries(PAYLOAD_TYPE_LABEL).map(([value, label]) => ({ value, label }));
